import { render, staticRenderFns } from "./Tire.vue?vue&type=template&id=174642f0&scoped=true&"
import script from "./Tire.vue?vue&type=script&lang=js&"
export * from "./Tire.vue?vue&type=script&lang=js&"
import style0 from "./Tire.vue?vue&type=style&index=0&id=174642f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174642f0",
  null
  
)

export default component.exports